

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

import NavaBar from './component/NavaBar/NavaBar';
import Home from './pages/Home/Home';
import Footer from './component/Footer/Footer';
// import MyAccount from './component/MyAccount/MyAccount';
import Orders from './component/Orders/Orders';
import LoginModal from './component/Login/Login';
import OurStore from './component/OurStore/OurStore';
import Register from './component/Register/Register';
import Shipping_Delivery from './component/RentalAgreement/RentalAgreement';
import AccountDetails from './component/AccountDetails/AccountDetails';
import ContactUs from './component/ContactUs/ContactUs';
import Wishlist from './component/Wishlist/Wishlist';
import Address from './component/Address/address';
import WhatsAppPopup from './component/WhatsAppButton/WhatsAppButton';
import ScrollToTopButton from './component/ScrollToTopButton/ScrollToTopButton';
import AdminHome from './component/adminDash/AdminHome';
import AdminAllProducts from './component/adminDash/adminAllProducts';
import AdminAddProduct from './component/adminDash/AdminAddProduct';
import Adminorders from './component/adminDash/Adminorders';
import Jodhpuri from './pages/Jodhpuri/Jodhpuri';
import Gallery from './pages/Gallery/Gallery';
// import ProductView from './pages/productpreview/productpreview';
import ProductPreview from './pages/ProductPreview/productpreview';
import CheckOut from './pages/CheckOut/CheckOut';
import AdminAddCategory from './component/adminDash/AdminAddCategory';
import AdminAddRentForm from './component/adminDash/AdminAddRentForm';
import AdminAddStyle from './component/adminDash/AdminAddStyle';
import Cart from './pages/Cart/Cart';
import Unauthorized from './component/Unauthorized/Unauthorized'; // Add unauthorized component
import { CartProvider } from './pages/CartContext/CartProvider';
import PrivateRoute from './component/PrivateRoute/PrivateRoute';
import OrderConfirmation from './pages/UserOrder/Order';
import AdminOrders from './component/adminDash/Adminorders';
import StockManagementPage from './component/adminDash/AdminStockManagment';
import SearchBar from './component/SearchBar/SearchBar'
import SideNavbaBarDashboard from './component/SideNavaBarDashboard/SideNavbaBarDashboard';
import Dashboard from './component/adminDash/AdminDashboard';
import NotFound from './pages/NotFound';
import FAQ from './component/FAQs/FAQ';
import Shipping from './pages/Shipping/Shipping';
import Demo from './pages/productdemo';
import ScrollToTop from './component/Scrollup';
import RentalAgreement from './component/RentalAgreement/RentalAgreement';
import PrivacyPolicy from './component/PrivacyPolicy/PrivacyPolicy';
import ReturnsExchanges from './component/ReturnsExchanges/ReturnsExchanges';
import TermsConditions from './component/Terms&Conditions/Terms&Conditions';
import RentalProcess from './pages/RentalProcess/rentalprocess';
import OtherProductPreview from './pages/OtherProductPreview/OtherProductPreview';
import AdminEditCategory from './component/adminDash/AdminEditCategory';
import AdminEditStyle from './component/adminDash/AdminEditStyle';
import Instagram from './component/Instagram/Instagram/Instagram'
import LinkedIn from './component/LinkedIn/LinkedIn';
import FaceBook from './component/FaceBook/FaceBook/FaceBook'
import AdminDashboard from './component/adminDash/Salesreport/AdminDashBoard';
// Create AppContent component to use hooks (since we need useLocation and useNavigate)
const AppContent = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Open modal when the path is /login
    if (location.pathname === '/login') {
      setIsLoginModalOpen(true);
    }
  }, [location.pathname]);

  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
    // Only update URL if we're on the login page
    if (location.pathname === '/login') {
      navigate('/', { replace: true });
    }
  };

  const handleLoginClick = (e) => {
    if (location.pathname === '/login') {
      e.preventDefault();
      setIsLoginModalOpen(true);
    }
  };

  return (
    <div id="wrapper">
      <NavaBar onLoginClick={handleLoginClick} />
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path='/demo' element={<Demo/>}/>
        <Route path='/Shipping-Policy' element={<Shipping/>}/>
        <Route path="/" element={<Home />} />
        {/* <Route path="/Myaccount" element={<MyAccount />} /> */}
        <Route path="/orders" element={<Orders />} />
        <Route path="/ourstore" element={<OurStore />} />
        <Route path="/register" element={<Register />} />
        <Route path='/FAQs' element={<FAQ/>}/>
        <Route path="/RentalAgreement" element={<RentalAgreement />} />
        <Route path="/accountdetails" element={<AccountDetails />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/address" element={<Address />} />
        <Route path="/products" element={<Jodhpuri />} />
        <Route path="/Galley" element={<Gallery />} />
        <Route path="/SearchBar" element={<SearchBar />} />
        <Route path="/OrderConfirm" element={<OrderConfirmation />} />
        <Route path='/UserDashboard' element={<SideNavbaBarDashboard/>}/>
        {/* <Route path="/productpreview/:productId" element={<ProductView />} /> */}
        <Route path='/productpreview' element={<ProductPreview/>}/>
        <Route path="/Cart" element={<Cart />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/login" element={<Home />} />
        <Route path='/Terms&Conditions' element={<TermsConditions/>}/>
        <Route path='/Cancellations&Refunds' element={<ReturnsExchanges/>}/>
        <Route path='/Privacy-Policy' element={<PrivacyPolicy/>}/>
        <Route path='/rentalprocess' element={<RentalProcess/>}/>
        <Route path='/salesreport' element={
          <PrivateRoute allowedRoles={["admin"]}>
          <AdminDashboard/>
          </PrivateRoute>
        }/>
        {/* <Route path="/otherProductPreview" element={<OtherProductPreview/>}/> */}
        {/* Protected Routes for Logged-In Users */}
        <Route
          path="/checkout"
          element={
            <PrivateRoute allowedRoles={["user", "admin"]}>
              <CheckOut />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/dashboard"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        /> */}

        {/* Admin Routes */}
        <Route
          path="/admindashboard"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminHome />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Dashboard />
            </PrivateRoute>
          }
        />
         <Route
          path="/ProductManagement"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <StockManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminallProducts"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminAllProducts />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminaddproduct"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminAddProduct />
            </PrivateRoute>
          }
        />
         <Route
          path="/Styles"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminEditStyle />
            </PrivateRoute>
          }
        />
      <Route
          path="/Category"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminEditCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminorders"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Adminorders />
            </PrivateRoute>
          }
        />
        <Route
          path="/admincategory"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminAddCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminrentform"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminAddRentForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminstyle"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminAddStyle />
            </PrivateRoute>
          }
        />
        <Route
          path="/AdminOrders"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminOrders />
            </PrivateRoute>
          }
        />
        <Route path='*' element={<NotFound/>}/>
      </Routes>

      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={handleCloseLoginModal}
      />

      <ScrollToTopButton />
      <WhatsAppPopup />
      <Footer />
      <Instagram/>
      <FaceBook/>
    </div>
  );
};

// Main App component
const App = () => {
  return (
    <CartProvider>
      <Router>
        <AppContent />
      </Router>
    </CartProvider>
  );
};

export default App;
